import Bowser from 'bowser';
import { TMN_APP_VERSION, IOS_VERSION, ANDROID_VERSION, CHROME_VERSION } from '../constants';

type OsCustom = {
    name: string;
    version: string | undefined;
};

type Options = {
    lexicographical: string;
    zeroExtend: boolean;
};

export function osDetection(): OsCustom | undefined {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const OSDetect = browser.getOS();
    if (!OSDetect.name) return undefined;
    return {
        name: OSDetect.name,
        version: OSDetect.version,
    };
}

export function browserDetection(): OsCustom | undefined {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserDetect = browser.getBrowser(); //{name, version}
    if (!browserDetect.name) return undefined;
    return {
        name: browserDetect.name,
        version: browserDetect.version,
    };
}

export function isDeviceCompatible(): boolean {
    let result = true;
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserDetect = browser.getBrowser(); //{name, version}
    const OSDetect = browser.getOS(); //{name, version}
    if (!OSDetect.name || !browserDetect.name || !browserDetect.version) return false;
    if (OSDetect && OSDetect.name.toLowerCase() === 'ios' && OSDetect.version && !versionCompare(OSDetect.version, IOS_VERSION)) {
        result = false;
    }

    if (OSDetect && OSDetect.name.toLowerCase() === 'android' && OSDetect.version && !versionCompare(OSDetect.version, ANDROID_VERSION)) {
        result = false;
    }

    if (browserDetect && browserDetect.name.toLowerCase() === 'chrome' && !versionCompare(browserDetect.version, CHROME_VERSION)) {
        result = false;
    }
    return result;
}

export function isTMNVerCompatible(): boolean {
    const tmnapp = window.navigator.userAgent;
    if (!tmnapp) return false;
    const myRegexp = /(?:^|\s)TrueMoneyVersion\/(.*?)(?:\s|$)/g;
    const match = myRegexp.exec(tmnapp);
    if (!match || (match && match.length <= 0)) return false;
    return versionCompare(match[1], TMN_APP_VERSION);
}

function versionCompare(v1: string, v2: string, options?: Options): boolean {
    const lexicographical = options && options.lexicographical;
    const zeroExtend = options && options.zeroExtend;
    let v1parts: string[] | number[] = v1.split('.');
    let v2parts: string[] | number[] = v2.split('.');

    function isValidPart(x: string) {
        return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
    }

    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
        return false;
    }

    if (zeroExtend) {
        while (v1parts.length < v2parts.length) v1parts.push('0');
        while (v2parts.length < v1parts.length) v2parts.push('0');
    }

    if (!lexicographical) {
        v1parts = v1parts.map(Number);
        v2parts = v2parts.map(Number);
    }

    for (let i = 0; i < v1parts.length; ++i) {
        if (v2parts.length === i) {
            return true;
        }

        if (v1parts[i] === v2parts[i]) {
            continue;
        } else if (v1parts[i] > v2parts[i]) {
            return true;
        } else {
            return false;
        }
    }

    if (v1parts.length !== v2parts.length) {
        return false;
    }

    return true;
}
